module.exports = __webpack_public_path__ + "static/media/restaurant6.9da7f721.jpg";